exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-collapse-item__content .gallery{flex-direction:row;display:flex;flex-wrap:wrap;justify-content:space-around}.el-collapse-item__content .gallery .wrapper{flex:none;padding:0}.el-collapse-item__content{overflow-y:auto;max-height:600px}.el-collapse-item__header{font-size:18px;color:#205d91;height:auto;line-height:25px;padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-46349c4a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/components/portfolio/portfolio.vue
// module id = 574
// module chunks = 0